import './styles/listing/index.scss';

import { app } from './bootstrap';

import CardController from './controllers/listing/card_manual_controller';

app.register('listing--card', CardController);
